import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { PlatformParams, PlatformState } from './types';

export const usePlatformStore = create<PlatformState>()(
  persist(
    (set) => ({
      params: {},
      isInitialized: false,
      isPorte: false,

      setParams: (params) =>
        set((state) => ({
          params: { ...state.params, ...params },
        })),

      initFromUrl: (params: PlatformParams) => {
        const isPorte =
          Boolean(params.token) ||
          Boolean(params.client_id) ||
          Boolean(params.client_phone) ||
          Boolean(params.client_email) ||
          Boolean(params.source) ||
          Boolean(params.room_number) ||
          (Boolean(params.lat) && Boolean(params.long));

        set((state) => ({
          params: { ...state.params, ...params },
          isInitialized: true,
          isPorte,
        }));
      },

      reset: () =>
        set(() => ({
          params: {},
          isInitialized: false,
        })),
    }),
    {
      name: 'platform-storage',
    }
  )
);
